// Same shape as the tech version, but reads its API base from the client env.

const API_BASE =
  process.env.REACT_APP_API_BASE ||
  (typeof window !== 'undefined' && window.__REMOTEEYES_API__) ||
  '';

export function buildWsUrl(sessionId, role, token) {
  const base = API_BASE || `${window.location.protocol}//${window.location.host}`;
  const url = new URL(base);
  url.protocol = url.protocol === 'https:' ? 'wss:' : 'ws:';
  url.pathname = `/ws/${sessionId}`;
  url.searchParams.set('role', role);
  if (token) url.searchParams.set('t', token);
  return url.toString();
}

export class Signaling {
  constructor(sessionId, role, token) {
    this.sessionId = sessionId;
    this.role = role;
    this.token = token;
    this.ws = null;
    this.handlers = new Map();
    this.pendingSend = [];
    this.reconnectAttempts = 0;
    this.shouldReconnect = true;
  }

  on(type, fn) { this.handlers.set(type, fn); return this; }
  emit(type, data) { const fn = this.handlers.get(type); if (fn) fn(data); }

  connect() {
    const url = buildWsUrl(this.sessionId, this.role, this.token);
    const ws = new WebSocket(url);
    this.ws = ws;

    ws.onopen = () => {
      this.reconnectAttempts = 0;
      this.emit('open');
      while (this.pendingSend.length) ws.send(this.pendingSend.shift());
    };

    ws.onmessage = (e) => {
      let msg;
      try { msg = JSON.parse(e.data); } catch { return; }
      this.emit('message', msg);
      if (msg.type) this.emit(msg.type, msg);
    };

    ws.onclose = () => {
      this.emit('close');
      if (!this.shouldReconnect) return;
      const delay = Math.min(15000, 500 * Math.pow(2, this.reconnectAttempts++));
      setTimeout(() => this.connect(), delay);
    };

    ws.onerror = (err) => this.emit('error', err);
  }

  send(type, payload = {}) {
    const data = JSON.stringify({ type, ...payload });
    if (this.ws && this.ws.readyState === WebSocket.OPEN) this.ws.send(data);
    else this.pendingSend.push(data);
  }

  close() { this.shouldReconnect = false; if (this.ws) this.ws.close(); }
}
